import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CacheManager } from '../utils/cacheManager';

/**
 * Hook to handle cache clearing when user logs out
 * This ensures all component state is properly reset
 */
export const useCacheClear = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      CacheManager.clearAllCache();
    }
  }, [isAuthenticated]);
};

/**
 * Hook to clear user-specific cache when user changes
 * @param userId - Current user ID
 */
export const useUserCacheClear = (userId: number | null) => {
  useEffect(() => {
    if (userId) {
      CacheManager.clearUserCache(userId);
    }
  }, [userId]);
};

/**
 * Hook to handle complete logout with cache clearing
 * @returns logout function that clears all cache
 */
export const useLogoutWithCacheClear = () => {
  const { logout } = useAuth();

  const logoutWithCacheClear = () => {
    logout();
    
    // Additional cache clearing for extra safety
    CacheManager.clearAllCache();
    
    setTimeout(() => {
      window.location.href = '/login';
    }, 100);
  };

  return logoutWithCacheClear;
};
